export default __webpack_public_path__ + "static/media/AssetTablerp.f00f2b4f.webp";